export default __webpack_public_path__ + "static/media/bears_white.d2732193.png";